import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import QuoteEditor from "@/pages/QuoteEditor";
import Settings from "@/pages/Settings";
import Catalog from "@/pages/Catalog";
import Clients from "./pages/Clients";
import Billing from "@/pages/Billing";
import PromoCodes from "@/pages/PromoCodes";
import SuperAdmin from "@/pages/SuperAdmin";
import PublicProposal from "@/pages/PublicProposal";
import PreviewFrame from "@/pages/PreviewFrame";
import Certificate from "@/pages/Certificate";
import { Terms, Privacy, Dpa, CookiePolicy } from "@/pages/Legal";
import CookieBanner from "@/components/CookieBanner";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/dpa" element={<Dpa />} />
            <Route path="/p/:token" element={<PublicProposal />} />
            <Route path="/preview-frame" element={<PreviewFrame />} />
            <Route path="/c/:token" element={<Certificate />} />
            <Route path="/" element={<Landing />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/quotes/new" element={<Protected><QuoteEditor /></Protected>} />
            <Route path="/quotes/:id/edit" element={<Protected><QuoteEditor /></Protected>} />
            <Route path="/catalog" element={<Protected><Catalog /></Protected>} />
            <Route path="/clients" element={<Protected><Clients /></Protected>} />
            <Route path="/promo-codes" element={<Protected><PromoCodes /></Protected>} />
            <Route path="/billing" element={<Protected><Billing /></Protected>} />
            <Route path="/super-admin" element={<Protected><SuperAdmin /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
